const Colors = {
    primaryColor: '#97B43C',
    colorGray: '#CCCCCC',
    colorDarkGrey: '#707070',
    colorRed: '#A73E3E',
    colorModal: 'rgba(0,0,0,0.7)'
}

export default Colors;